import type ApplicationController from '@aha-app/mvc';
import { addBreadcrumb } from '@sentry/browser';
import { type Constructor } from 'javascripts/shared-types';
import makeDebugger from 'javascripts/util/devLog';

const debug = makeDebugger('mvc:controller:actions');

export function actionLogger(controllerName: string) {
  return function (controllerClass: Constructor<ApplicationController>): any {
    return class extends controllerClass {
      constructor(...args) {
        super(...args);

        return new Proxy(this, {
          get(target, prop, receiver) {
            const value = Reflect.get(target, prop, receiver);
            if (
              typeof value === 'function' &&
              typeof prop === 'string' &&
              prop.startsWith('action')
            ) {
              return function (...args) {
                const message = `Action called: ${controllerName}.${prop}`;

                addBreadcrumb({
                  category: 'ApplicationController',
                  message,
                  data: {
                    args,
                  },
                });

                debug(message, args);

                return (value as Function).apply(this, args);
              };
            }

            return value;
          },
        });
      }
    };
  };
}
